<template>
<div>
    <BlogTemplate :blogId="blogId"/>
</div>
    
</template>

<script>
import BlogTemplate from '@/components/BlogComponents/BlogTemplate';

export default {
    data() {
        return {
            blogId: 1,
        }
    },
    components: {
        BlogTemplate
    }
}
</script>
